import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

// Thème par marque, choisi au build (VITE_BRAND) : « umbeli » = blanc/bleu flat,
// sinon palette Maple & Coast (défaut). Import dynamique pour que Vite ne charge
// qu'un seul CSS au runtime ; on attend le CSS avant de rendre (pas de flash).
const brand = import.meta.env.VITE_BRAND === "umbeli" ? "umbeli" : "maple";
const styles =
  brand === "umbeli" ? import("./styles/index-umbeli.scss") : import("./styles/index.scss");

void styles.finally(() => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
});
